<template>
  <v-row class="h-full justify-center algin-center d-flex py-4 ma-0">
    <v-col
      cols="12"
      sm="6"
      lg="4"
      style="maxwidth: 600px"
      class="d-flex flex-column align-center justify-center ma-0"
    >
      <v-card class="w-full">
        <v-card-title class="d-flex justify-center">
          <r-img
            alt="Company Logo"
            class="my-2"
            :src="logo"
            max-width="140"
          />
        </v-card-title>

        <v-card-text v-if="isLoading">
          <div class="d-flex flex-column align-center">
            <v-progress-circular
              indeterminate
              color="primary"
              width="3"
              size="30"
            />
            <p>{{ $t('crm.on-office-confirmation.loading-text', { readablePlatformName }) }}</p>
          </div>
        </v-card-text>

        <v-card-text v-if="hasError">
          <v-alert
            class="ma-0"
            type="error"
          >
            <span>
              {{ $t(`crm.on-office-confirmation.error-alert.${error}`, { errorMessage }) }}
            </span>
          </v-alert>
        </v-card-text>

        <v-card-text v-if="isConnected">
          <v-alert
            class="ma-0"
            type="success"
          >
            <span>
              {{ $t('crm.on-office-confirmation.success-alert.title') }}<br />
              {{
                $t('crm.on-office-confirmation.success-alert.description', { readablePlatformName })
              }}
            </span>
          </v-alert>
          <p class="mt-2 text-subtitle-1">
            <b>{{ $t('crm.on-office-confirmation.caution') }}:</b>
            {{ $t('crm.on-office-confirmation.caution-text.prefix') }}
            <router-link to="/settings/crm">
              <b>{{ $t('crm.on-office-confirmation.caution-text.link-text') }}</b>
            </router-link>
            {{ $t('crm.on-office-confirmation.caution-text.suffix') }}
          </p>
          <v-btn
            color="primary"
            class="w-full"
            :to="'/settings/crm'"
          >
            {{ $t('crm.on-office-confirmation.button-text') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import logo from '@/assets/img/logo.png'
import bus, { eventNames } from '@/lib/eventBus'
import brandingMixin from '@/mixins/branding'

import CONNECT_ONOFFICE_USER from './ConnectOnofficeUser.gql'

export default {
  mixins: [brandingMixin],
  data() {
    return {
      error: null,
      submitState: 'PENDING',
      logo,
    }
  },
  computed: {
    hasError() {
      return this.error !== null
    },
    isConnected() {
      return this.error === null && this.submitState === 'FINISHED'
    },
    isLoading() {
      return this.submitState === 'PENDING'
    },
    errorMessage() {
      return {
        unknown: this.$t('crm.on-office-confirmation.error-alert.unknown'),
        invalidToken: this.$t('crm.on-office-confirmation.error-alert.invalid-token'),
      }[this.error]
    },
  },
  mounted() {
    const token = this.$route.params.token
    if (token) {
      this.connectOnOffice(token)
    }
  },
  methods: {
    async connectOnOffice(token) {
      this.error = null
      this.submitState = 'PENDING'
      try {
        await this.$apollo.mutate({
          mutation: CONNECT_ONOFFICE_USER,
          variables: {
            input: {
              token,
            },
          },
        })
        bus.$emit(eventNames.CRM_UPDATED)
        this.$router.replace({ path: '/settings/crm' })
      } catch (err) {
        if (err?.message?.match(/Invalid token/)) {
          this.error = 'invalidToken'
        } else {
          this.error = 'unknown'
        }
      } finally {
        this.submitState = 'FINISHED'
      }
    },
  },
}
</script>
